<template>
	<div class="page">
		<div class="searchBox">
			<el-form>
				<el-row>
					<el-col :span="2">
						<el-form-item>
							印章详情
						</el-form-item>
					</el-col>
					<el-col :span="1" :offset="21">
						<el-form-item>
							<el-button type="warning" size="mini" @click="back">返回</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="contentBox">
			<div class="msgBox">
				<div class="msgImg">
					<img class="img" :src="detail.sealUrl"/>
				</div>
				<div class="msgImgR">
					<div class="msgLine" style="font-weight: bold;">{{detail.sealName||'--'}}</div>
					<div class="msgLine">印章类型：{{$types.get_signature_type(detail.sealType)}}
					</div>
					<!-- <div class="msgLine">印章编号：{{detail.sealName}}</div> -->
					<div class="msgLine">生成时间：{{$public.FTime(detail.createTime)}}</div>
				</div>
			</div>
			<div class="tableBox">
				<el-table :data="tableData" style="width: 100%">
					<el-table-column label="序号" width="50">
						<template slot-scope="props">
							{{parseInt(props.$index+1)}}
						</template>
					</el-table-column>
					<el-table-column label="文件编号" prop="contractNum" >
					</el-table-column>
					<el-table-column label="业务类型" prop="medicalServiceName" >
						<template slot-scope="props">
							{{$types.get_fileTemplate_type(props.row.contractType)}}
						</template>
					</el-table-column>
					<el-table-column label="顾客" prop="memberName" >
					</el-table-column>
					<el-table-column label="手机号" prop="memberMobile" >
					</el-table-column>
					<el-table-column label="宠物" prop="petName" >
					</el-table-column>
					<el-table-column label="签署状态" prop="birthDay" >
						<template slot-scope="props">
							<span v-if="props.row.state===2">已失效</span>
							<span v-if="props.row.state===1">
								<span v-if="props.row.signState===1">待签署</span>
								<span v-if="props.row.signState===2">已签署</span>
								<span v-if="props.row.signState===3">已领走</span>
							</span>
						</template>
					</el-table-column>
					<el-table-column label="创建时间" prop="typeName" >
						<template slot-scope="props">
							<div>{{$public.FTime(props.row.createTimeStamp,'YYYY-MM-DD')}}</div>
						</template>
					</el-table-column>
					<el-table-column label="签署时间" >
						<template slot-scope="props">
							<div>{{$public.FTime(props.row.signTime,'YYYY-MM-DD')}}</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="60">
						<template slot-scope="props">
							<el-button type="text" size="mini" @click="see(props.row)">查看</el-button>
						</template>
					</el-table-column>
				</el-table>
				<page style="padding:10px 0;" :page="page.page" :total="page.total" @change="changePage"></page>
			</div>
		</div>
	</div>
</template>
<script>
	import page from "../../components/page.vue"
	export default {
		components:{page},
		data(){
			return{
				detail:{},
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData:[],
				
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		mounted(){
			this.getDetail();
		},
		methods: {
			back(){
				this.$router.back()
			},
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			getDetail(){
				let loading = this.$loading();
				this.$http.get('/api/Contract/Seal/Detail', {id:this.$route.query.id}).then(res => {
					loading.close()
					if (res.code == 0) {
						this.detail = res.data;
						this.page.page=1;
						this.getTableData();
					}
				})
			},
			getTableData(){
				let params = {
					isLink:-1,
					sealId:this.detail.id,
					desc:true,
					pageIndex:this.page.page,
					pageSize:this.page.pageSize,
				}
				let loading = this.$loading();
				this.$http.post('/api/Contract/Order/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			// 查看
			see(row){
				let loading = this.$loading();
				this.$http.get('/api/Contract/Order/Detail', {contractNum:row.contractNum}).then(res => {
					loading.close()
					if (res.code == 0) {
						window.open(res.data.signContractPdfUrl)
					}
				})
			},
		}
	}
</script>
<style scoped lang="scss">
.page{
	.searchBox {
		.el-form-item {
			margin-bottom: 0;
		}
	}
	.contentBox{
		margin-top:12px;background-color: #fff;
		.msgBox{
			display: flex;padding:16px;
			.msgImg{
				width:252px;height: 195px;border:1px solid #d5d5d5;display: flex;align-items: center;justify-content: center;
				.img{
					width:155px;height: 150px;
				}
			}
			.msgImgR{
				padding-left:15px;padding-top:15px;
				.msgLine{
					font-size: 16px;color:#2a2a2a;padding-top:20px;
				}
			}
		}
		.tableBox{
			padding-top:30px;
		}
	}
}
</style>
